import type { TFormModel } from 'components/form/types/formModel'
import type { TFormFieldDict } from 'components/form/types/field'
import type { ComputedRef, Ref } from 'vue'
import type { StringIndexable } from '@/types/object'
import { reactiveComputed } from '@vueuse/core'
import type { UseFormProps } from '.'

export type UseFormStatsState = {
  changeCount: number
  touched: boolean
}

export type UseFormStateProps<T extends TFormModel = { [key: string]: any }, ContextType extends (StringIndexable | undefined) = StringIndexable> = UseFormProps<T, ContextType> & {
  fields: Ref<TFormFieldDict<T>> | ComputedRef<TFormFieldDict<T>>
}

export const useFormStats = <T extends StringIndexable = StringIndexable, ContextType extends (StringIndexable | undefined) = StringIndexable>(
  _props: UseFormStateProps<T, ContextType>
) => {
  const state = reactiveComputed<UseFormStatsState>(() => {
    return {
      changeCount: 0,
      touched: true
    }
  });

  const setTouched = (touched: boolean) => {
    state.touched = touched;
  }

  const reset = () => {
    state.touched = false;
    state.changeCount = 0;
  }

  return { state, setTouched, reset }
}

export type UseFormStatsReturn<T extends StringIndexable = StringIndexable, ContextType extends (StringIndexable | undefined) = StringIndexable> = ReturnType<
  typeof useFormStats<T, ContextType>
>
